import React, { useState, useEffect, useRef } from "react";
import Header from "../Section/Header";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  Edit3,
  Clock,
  Eye,
  User,
  MapPin,
  Calendar as CalendarIcon,
  Search,
} from "lucide-react";
import Footer from "../Section/Footer";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  create_horoscope,
  delete_for_android,
  server_post_data,
  view_subjecsts,
} from "../../ServiceConnection/serviceconnection";
import { formatDOB } from "../../CommonJquery/CommonJquery";
import { CustomAlert } from "../../CommonJquery/CustomAlert";
import SearchListData from "../Section/SearchListData";
export default function KundaliPage() {
  const timeInputRef = useRef(null);
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("kundli");
  const [selectedKundaliId, setSelectedKundaliId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showModal , setshowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    dob: null,
    time: "",
    place: "",
    language: "english",
    saveKundali: true,
    latitude: "",
    longitude: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  console.log("form_lo", formData.place);
  const resetFormData = () => {
    setFormData({
      name: "",
      gender: "",
      dob: null,
      time: "",
      place: "",
      language: "english",
      saveKundali: true,
      latitude: "",
      longitude: "",
    });
    setIsEditing(false);

    setErrors({});
  };
  const formatTimeForInput = (timeString) => {
    if (!timeString) return "";

    // If it's already in HH:MM format, return as is
    if (/^\d{2}:\d{2}$/.test(timeString)) {
      return timeString;
    }

    // If it's in HH:MM:SS format, remove seconds
    if (/^\d{2}:\d{2}:\d{2}$/.test(timeString)) {
      return timeString.substring(0, 5);
    }

    // If it's in 12-hour format (like "02:30 PM"), convert to 24-hour
    if (timeString.includes("AM") || timeString.includes("PM")) {
      const [time, period] = timeString.split(" ");
      const [hours, minutes] = time.split(":");
      let hour24 = parseInt(hours);

      if (period === "PM" && hour24 !== 12) {
        hour24 += 12;
      } else if (period === "AM" && hour24 === 12) {
        hour24 = 0;
      }

      return `${hour24.toString().padStart(2, "0")}:${minutes}`;
    }
    return timeString;
  };
  const handleEditKundali = (kundali) => {
    const dobParts = kundali.user_dob.split("-");
    const dobDate = new Date(dobParts[0], dobParts[1] - 1, dobParts[2]);

    // Combine place data
    const placeString = `${kundali.city_name}, ${kundali.state_name}, ${kundali.country_name}`;

    // Format time for HTML input
    const formattedTime = formatTimeForInput(kundali.user_dobtime2);

    setFormData({
      name: kundali.user_name || "",
      gender: kundali.user_gender || "",
      dob: dobDate,
      time: formattedTime, // Use formatted time
      place: placeString,
      language: "english",
      saveKundali: true,
      latitude: kundali.latitude_data || "",
      longitude: kundali.longitude_data || "",
    });

    setIsEditing(true);
    setActiveTab("kundli");
    setErrors({});
    setshowModal(false);
  };
  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Please enter your full name.";
    if (!formData.gender) newErrors.gender = "Please select your gender.";
    if (!formData.dob) newErrors.dob = "Please select your birth date.";
    if (!formData.time) newErrors.time = "Please select your birth time.";
    if (!formData.place.trim())
      newErrors.place = "Please enter your birth place.";
    if (!formData.language) newErrors.language = "Please select your language.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  useEffect(() => {
    if (!window.google) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["(cities)"],
        componentRestrictions: { country: "in" },
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      const formatted = place.formatted_address || place.name || "";

      const lat = place.geometry?.location?.lat();
      const lng = place.geometry?.location?.lng();

      setFormData((prev) => ({
        ...prev,
        place: formatted,
        latitude: lat ? lat.toFixed(6) : "",
        longitude: lng ? lng.toFixed(6) : "",
      }));

      setErrors((prev) => ({ ...prev, place: "" }));
    });

    return () => {
      window.google.maps.event.clearInstanceListeners(autocomplete);
    };
  }, []);

  const splitPlace = (placeString) => {
    if (!placeString) return { city: "", state: "", country: "" };

    const parts = placeString.split(",").map((part) => part.trim());

    return {
      city: parts[0] || "",
      state: parts[1] || "",
      country: parts[2] || "",
    };
  };

  const handleDynamic = async (type) => {
    setIsLoading(true);
    const { city, state, country } = splitPlace(formData.place);
    const dobDate = new Date(formData.dob);
    const dobYear = dobDate.getFullYear();
    const dobMonth = String(dobDate.getMonth() + 1).padStart(2, "0");
    const dobDay = String(dobDate.getDate()).padStart(2, "0");
    const fd = new FormData();
    fd.append("flag", 7);
    fd.append("sub_id", 0);
    fd.append("cat_id", 0);
    fd.append("thread_id", 0);
    fd.append("user_name", formData.name);
    fd.append("user_dob", `${dobYear}-${dobMonth}-${dobDay}`);
    fd.append("user_dobtime", formData.time);
    fd.append("city_name", city);
    fd.append("state_name", state);
    fd.append("contry_name", country);
    fd.append("user_gender", formData.gender);
    fd.append("latitude_data", formData.latitude);
    fd.append("longitude_data", formData.longitude);
    let gender = formData.gender;
    await server_post_data(create_horoscope, fd)
      .then((Response) => {
        setIsLoading(false);
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          setShowSuccessModal(true);
          resetFormData();
          masterDataGet(); // Refresh the saved kundalis list
          handleNavigate(data[3], gender);
          setTimeout(() => {
            setShowSuccessModal(false);
          }, 2000);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      console.log("Submitted:", formData);

      handleDynamic();
    }
  };
  //:-------------------------Saved Kundali Data------------------------------

  const [topicList, setTopicList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredTopicList, setFilteredTopicList] = useState(topicList);

  useEffect(() => {
    if (searchText === "") {
      setFilteredTopicList(topicList);
    } else {
      const filteredList = topicList
        .filter(
          (item) =>
            item.user_name &&
            item.user_name.toLowerCase().includes(searchText.toLowerCase())
        )
        .sort((a, b) => (a.user_name || "").localeCompare(b.user_name || ""));
      setFilteredTopicList(filteredList);
    }
  }, [searchText, topicList]);

  useEffect(() => {
    masterDataGet();
  }, []);
  const masterDataGet = async () => {
    setIsLoading(true);
    const fd = new FormData();
    fd.append("flag", 7);
    fd.append("sub_id", 0);
    fd.append("cat_id", 0);
    fd.append("thread_id", 0);

    await server_post_data(view_subjecsts, fd)
      .then(async (Response) => {
        setIsLoading(false);
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          setTopicList(JSON.parse(JSON.parse(data[1])[0]["get_data_subs"]));
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const handleShowDltModal = (kundaliId) => {
    setSelectedKundaliId(kundaliId);
    setShowDeleteModal(true);
    setshowModal(false);
  };
  const deletedata = async (flag_for) => {
    const form_data = new FormData();
    form_data.append("delete_idd", selectedKundaliId);
    form_data.append("flag_for", 1);
    setIsLoading(true);
    await server_post_data(delete_for_android, form_data)
      .then((Response) => {
        masterDataGet();

        setShowDeleteModal(false);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const openTimePicker = () => {
    if (timeInputRef.current) {
      timeInputRef.current.showPicker();
    }
  };
  const handleNavigate = (id, user_gender) => {
    navigate(`/kundli/kundli-details/${id}/${user_gender}`);
  };
  // Handle tab change - reset form if switching away from editing
  const handleTabChange = (tab) => {
    if (tab !== "kundli" && isEditing) {
      resetFormData();
    }
    setActiveTab(tab);
  };
  const handleShowSaveSearchModl = () => {
    console.log("clickeck")
    setshowModal(true);
    masterDataGet()
  };
  const handleClose = () => {
    setshowModal(false);
  };
  return (
    <>
      <Header />
      <div className="bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow">
        <section className="max-w-2xl mx-auto py-10 px-4">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-4">
              ⭐ {isEditing ? "Edit Kundli" : "Create New Kundli"}
            </h2>
            <p className="text-lg text-purple-300">
              {isEditing
                ? "Update your kundali details and regenerate"
                : "Generate your personalized birth chart with detailed astrological insights"}
            </p>
          </div>

          <div className="flex justify-center gap-9 mt-4 mb-3 border-b border-white/20">
            <button
              type="button"
              onClick={() => handleTabChange("kundli")}
              className={`pb-2 border-b-2 transition-all duration-300 font-medium text-base
                ${
                  activeTab === "kundli"
                    ? "border-[var(--primary-color)] text-[var(--white)] opacity-100"
                    : "border-transparent text-[var(--light-purple)] kundali_tabs"
                }`}
            >
              💮 {isEditing ? "Edit Kundli" : "New Kundli"}
            </button>

            <button
              type="button"
              onClick={() => handleTabChange("saved")}
              className={`pb-2 border-b-2 transition-all duration-300 font-medium text-base relative
                ${
                  activeTab === "saved"
                    ? "border-[var(--primary-color)] text-[var(--white)] opacity-100"
                    : "border-transparent text-[var(--light-purple)] kundali_tabs"
                }`}
            >
              📋 Saved Kundli
              {topicList.length > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {topicList.length}
                </span>
              )}
            </button>
          </div>

          {activeTab === "kundli" && (
            <div
              className="rounded-lg text-card-foreground shadow-sm bg-slate-800/50 backdrop-blur-sm"
              style={{
                borderColor: "var(--primary-border)",
                borderWidth: "1.5px",
              }}
            >
              <div className="flex flex-col space-y-1.5 p-6 text-center">
                <h3 className="font-semibold tracking-tight text-2xl text-purple-100">
                  {isEditing ? "Edit Birth Details" : "Birth Details"}
                </h3>
                <p className="text-sm text-purple-300">
                  {isEditing
                    ? "Update your birth information and regenerate kundali"
                    : "Provide accurate birth information for precise calculations"}
                </p>
                {isEditing && (
                  <div className="flex justify-center gap-2 mt-2">
                    <button
                      type="button"
                      onClick={resetFormData}
                      className="text-xs px-3 py-1 bg-gray-600/50 hover:bg-gray-600/70 text-gray-300 rounded-full transition-all"
                    >
                      Cancel Edit
                    </button>
                  </div>
                )}
              </div>

              <div className="p-6 pt-0">
                <form className="space-y-6" onSubmit={handleSubmit}>
                  {/* Full Name */}
                  <div className="space-y-1">
                    <label
                      htmlFor="name"
                      className="text-sm font-medium text-purple-200"
                    >
                      Full Name <span className="text-red-400">*</span>
                    </label>
                    <div className="flex items-center justify-between h-11 w-full rounded-md px-3 py-3 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border">
                      <input
                        type="text"
                        id="name"
                        placeholder="Enter your full name"
                        className="custum_input"
                        style={{
                          borderColor: "var(--primary-border)",
                          borderWidth: "1.5px",
                        }}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData({ ...formData, name: e.target.value });
                          setErrors({ ...errors, name: "" });
                        }}
                      />
                      <button
                        type="button"
                        aria-label="Search"
                        onClick={handleShowSaveSearchModl}
                      >
                        <Search
                          color="#c0a0e7"
                          className="mr-[-6px]"
                          size={20}
                        />
                      </button>
                    </div>

                    {errors.name && (
                      <span className="text-sm text-red-400">
                        {errors.name}
                      </span>
                    )}
                  </div>

                  {/* Gender */}
                  <div className="space-y-1 relative">
                    <label
                      htmlFor="gender"
                      className="text-sm font-medium text-purple-200"
                    >
                      Gender <span className="text-red-400">*</span>
                    </label>
                    <div className="relative">
                      <select
                        id="gender"
                        className="appearance-none h-11 w-full rounded-md px-3 py-2 pr-10 bg-slate-700/50 text-[var(--light-purple)] border"
                        style={{
                          borderColor: "var(--primary-border)",
                          borderWidth: "1.5px",
                        }}
                        value={formData.gender}
                        onChange={(e) => {
                          setFormData({ ...formData, gender: e.target.value });
                          setErrors({ ...errors, gender: "" });
                        }}
                      >
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                      <svg
                        className="w-4 h-4 text-purple-300 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                    {errors.gender && (
                      <span className="text-sm text-red-400">
                        {errors.gender}
                      </span>
                    )}
                  </div>

                  {/* Date of Birth */}
                  <div className="space-y-1 cusm_date_picker_container">
                    <label
                      htmlFor="dob"
                      className="text-sm font-medium text-purple-200"
                    >
                      Date of Birth <span className="text-red-400">*</span>
                    </label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={formData.dob ? dayjs(formData.dob) : null}
                        onChange={(date) => {
                          setFormData({
                            ...formData,
                            dob: date?.toDate() || null,
                          });
                          setErrors({ ...errors, dob: "" });
                        }}

                        slotProps={{
                          textField: {
                            fullWidth: true,
                            placeholder: "Select your birth date",
                            variant: "outlined",
                            className: "custom-datepicker",
                          },
                        }}
                      />
                    </LocalizationProvider>

                    {errors.dob && (
                      <span className="text-sm text-red-400 error_SPAN">
                        {errors.dob}
                      </span>
                    )}
                  </div>

                  {/* Time of Birth */}
                  <div
                    className="space-y-1 timeofBirth"
                    onClick={openTimePicker}
                  >
                    <label
                      htmlFor="time"
                      className="text-sm font-medium text-purple-200"
                    >
                      Time of Birth <span className="text-red-400">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="time"
                        id="time"
                        ref={timeInputRef}
                        className="appearance-none h-11 w-full rounded-md px-4 py-2 pr-10 bg-slate-700/50 text-[var(--light-purple)] border"
                        style={{
                          borderColor: "var(--primary-border)",
                          borderWidth: "1.5px",
                        }}
                        value={formData.time}
                        onChange={(e) => {
                          setFormData({ ...formData, time: e.target.value });
                          setErrors({ ...errors, time: "" });
                        }}
                      />
                      <Clock
                        size={18}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-purple-300 pointer-events-none"
                      />
                    </div>
                    {errors.time && (
                      <span className="text-sm text-red-400">
                        {errors.time}
                      </span>
                    )}
                  </div>

                  {/* Place of Birth */}
                  <div className="space-y-1">
                    <label
                      htmlFor="place"
                      className="text-sm font-medium text-purple-200"
                    >
                      Place of Birth <span className="text-red-400">*</span>
                    </label>
                    <input
                      ref={inputRef}
                      type="text"
                      id="place"
                      placeholder="City, State, Country"
                      className="h-11 w-full rounded-md px-4 py-2 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border"
                      style={{
                        borderColor: "var(--primary-border)",
                        borderWidth: "1.5px",
                      }}
                      value={formData.place}
                      onChange={(e) => {
                        setFormData({ ...formData, place: e.target.value });
                        setErrors({ ...errors, place: "" });
                      }}
                    />
                    {errors.place && (
                      <span className="text-sm text-red-400">
                        {errors.place}
                      </span>
                    )}
                  </div>

                  {formData.latitude?.length > 0 &&
                    formData.longitude?.length > 0 && (
                      <div className="flex items-center gap-4">
                        <div className="text-[12px] font-medium text-purple-200">
                          Latitude: {formData.latitude}
                        </div>
                        <div className="text-[12px] font-medium text-purple-200">
                          Longitude: {formData.longitude}
                        </div>
                      </div>
                    )}

                  {/* Save Kundali Checkbox */}
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id="saveKundali"
                      checked={formData.saveKundali}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          saveKundali: e.target.checked,
                        })
                      }
                      className="h-4 w-4 text-purple-600 border-purple-300 rounded focus:ring-purple-500"
                    />
                    <label
                      htmlFor="saveKundali"
                      className="text-sm text-purple-200"
                    >
                      Save Kundli
                    </label>
                  </div>

                  {/* Action Buttons */}
                  <div className="pt-4 space-y-4">
                    <button
                      type="submit"
                      className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-primary hover:bg-primary/90 h-10 px-4 py-4 w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-[var(--white)] font-semibold rounded-full"
                    >
                      {isEditing ? "Update Kundli" : "Generate Kundli"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {activeTab === "saved" && (
            <div className="space-y-4 ">
              <p className="text-[15px] text-[var(--light-pink-color)]">
                Recent Kundli
              </p>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <svg
                    className="h-5 w-5 text-purple-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  type="text"
                  placeholder="Search saved matches..."
                  className="w-full pl-12 pr-4 py-3 bg-slate-800/50 border border-purple-500/30 rounded-xl text-purple-100 placeholder-purple-400 focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500/50 transition-all duration-300 hover:border-purple-400/50"
                />
              </div>
              <div className="space-y-4 max_height_clss">
                {filteredTopicList.length === 0 ? (
                  <div className="text-center text-purple-300 border border-purple-500/20 bg-slate-800/30 p-6 rounded-lg">
                    💞 <strong>No Saved Kundalis</strong>
                    <p className="mt-2">
                      Create and save your first Kundali to see it here.
                    </p>
                  </div>
                ) : (
                  filteredTopicList.map((kundali, index) => (
                    <div
                      key={index}
                      className="rounded-lg border bg-slate-800/50 backdrop-blur-sm border-purple-500/20 p-4"
                    >
                      <div className="flex justify-between items-center">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <User size={16} className="text-purple-400" />
                            <h3 className="text-lg font-semibold text-purple-200">
                              {kundali.user_name}
                            </h3>
                            <span className="text-xs px-2 py-1 bg-purple-600/20 text-purple-300 rounded-full">
                              {kundali.user_gender}
                            </span>
                          </div>

                          <div className="space-y-1 text-sm text-purple-300">
                            <div className="flex items-center gap-2">
                              <CalendarIcon size={14} />
                              <span>{formatDOB(kundali.user_dob)}</span>
                              <Clock size={14} className="ml-2" />
                              <span>{kundali.user_dobtime2}</span>
                            </div>
                            <div className="flex items-center gap-2">
                              <MapPin size={14} />
                              <span>
                                {kundali.city_name} {kundali.state_name}{" "}
                                {kundali.country_name}{" "}
                              </span>
                            </div>
                            <div className="text-xs text-purple-400">
                              Saved on: {kundali.actual_date}
                            </div>
                          </div>
                        </div>

                        <div className="flex gap-2">
                          <button
                            onClick={() =>
                              handleNavigate(
                                kundali.horoscope_id,
                                kundali.user_gender
                              )
                            }
                            className="flex items-center gap-1 px-3 py-1 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white text-sm rounded-full transition-all"
                          >
                            <Eye size={14} />
                            View
                          </button>
                          <button
                            onClick={() => handleEditKundali(kundali)}
                            className="flex items-center gap-1 px-3 py-1 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white text-sm rounded-full transition-all"
                          >
                            <Edit3 size={14} />
                            Edit
                          </button>
                          <button
                            onClick={() => {
                              handleShowDltModal(kundali.horoscope_id);
                            }}
                            className="px-3 py-1 bg-red-600/20 hover:bg-red-600/40 text-red-400 text-sm rounded-full transition-all"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </section>
      </div>
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-slate-800 border border-purple-500/30 rounded-lg shadow-lg max-w-sm w-full p-6 text-center text-purple-100 animate-fade-in-down">
            <div className="text-4xl mb-2">🎉</div>
            <h2 className="text-lg font-semibold mb-2">Kundali Generated</h2>
            <p className="text-sm text-purple-300">
              Your kundali has been successfully generated!
            </p>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-dark">
            Are you sure you want to delete this Kundali?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="cencelmodalCustmclss text-[15px] py-[9px] px-5"
            onClick={() => setShowDeleteModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="bg-[var(--primary-color)] hover:bg-[var(--primary-hover-dark)] text-[15px] border-none py-[9px] px-5"
            variant="danger"
            onClick={deletedata}
          >
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
      {/**----------------------Search Modal------------------- */}
      <SearchListData
        showModal={showModal}
        handleClose={handleClose}
        searchText={searchText}
        setSearchText={setSearchText}
        filteredTopicList={filteredTopicList}
        handleEditKundali={handleEditKundali}
        handleNavigate={handleNavigate}
        handleShowDltModal={handleShowDltModal}
      />
      <Footer />
    </>
  );
}
